
const Messages = {
  CONTENT: {
    NONE: 'content://none',
    READY: 'content://ready'
  }
};

export { Messages }


// WEBPACK FOOTER //
// ./src/services/messages.ts